module.exports = __webpack_public_path__ + "img/popinjays.9e84bea0.jpg";